export default __webpack_public_path__ + "static/media/BookQuest5.7ae08316.jpg";